module.exports = __webpack_public_path__ + "img/speaker.be5030ca.webp";